import React from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { SystemAlert } from "@components/shared";

export default function BulkCommunicationAlerts({ id }) {
  const { data: alerts } = useQuery({
    initialData: [],
    queryKey: [`bulkCommunication${id}Alerts`],
    queryFn: async () =>
      axios
        .post(`/bulk-communicators/${id}/data-grabber/`, {
          context: `alerts`,
          bulk_communicator_id: id,
        })
        .then(({ data }) => {
          return data.response;
        })
        .catch((err) => {
          throw err;
        }),
  });

  const arr = alerts
    .filter((f) => f.trigger)
    .map((m) => ({
      ...m,
      level: m.color === "yellow" ? 1 : 2,
      path: m.alt_path
        ? `/${m.alt_path}`
        : `/bulk-communication/${id}${getConfigPathname(m.context)}`,
    }))
    .sort((a, b) => a.level - b.level);

  if (!arr.length) return null;

  return (
    <>
      {arr.map((alert, i) => (
        <SystemAlert alert={alert} key={i} />
      ))}
    </>
  );
}

function getConfigPathname(context) {
  switch (context) {
    case "template":
      return "/template";
    default:
      return "";
  }
}
